import { render } from "./RagChatDiagComp.vue?vue&type=template&id=3ec05064&scoped=true"
import script from "./RagChatDiagComp.vue?vue&type=script&lang=js"
export * from "./RagChatDiagComp.vue?vue&type=script&lang=js"

import "./RagChatDiagComp.vue?vue&type=style&index=0&id=3ec05064&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec05064"]])

export default __exports__